import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import WGS84Service from '../../../services/wgs84ProjectionService';
export default {
  name: 'ViewNiotaClassicGatewayManagementGWMap',
  data: function data() {
    return {
      camera: {
        center: [0, 0],
        zoom: 13
      },
      gwItems: [],
      gwClusters: [],
      boundingBox: {},
      selectedCluster: {},
      filterWarning: false,
      filterAlert: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])),
  watch: {
    filterWarning: function filterWarning() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    },
    filterAlert: function filterAlert() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    }
  },
  created: function created() {
    this.filterWarning = this.$route.query.warning === 'true';
    this.filterAlert = this.$route.query.alert === 'true';
    this.loadGWs();
  },
  methods: {
    loadGWs: function loadGWs() {
      var _this = this;

      var bounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      var accountId = this.$route.params.accountId ? parseInt(this.$route.params.accountId) : this.$store.state.authentication.tenantId;
      var options = [this.filterWarning ? 'warning' : null, this.filterAlert ? 'alert' : null].filter(function (o) {
        return o;
      });
      ApiService.gwMgmtFetchGeoData(accountId, bounds, options).then(function (data) {
        _this.boundingBox = data.boundingBox;

        if (_this.boundingBox.coordinates) {
          var northEast = {
            lat: -180,
            lon: -360
          };
          var southWest = {
            lat: 180,
            lon: 360
          };

          _this.boundingBox.coordinates.forEach(function (c) {
            northEast.lat = Math.max(northEast.lat, c[1]);
            southWest.lat = Math.min(southWest.lat, c[1]);
            northEast.lon = Math.max(northEast.lon, c[0]);
            southWest.lon = Math.min(southWest.lon, c[0]);
          });

          var mapContainer = _this.$refs.mapInstance.$el;
          var mapDimensions = {
            width: mapContainer.clientWidth - 30,
            height: mapContainer.clientHeight - 30
          };
          var zoomToUse = WGS84Service.boundsZoomLevel({
            northEast: northEast,
            southWest: southWest
          }, mapDimensions) - 0.5;
          _this.camera = {
            center: data.boundingBox.centroid,
            zoom: zoomToUse
          };
        }

        _this.gwItems = data.gateways;
        _this.gwClusters = data.clusters;
      }).catch(function (error) {
        console.error('Error loading map-gateway-geo-data', error);
      }).finally(function () {
        _this.$store.state.app.loading = false;
      });
    }
  }
};